module.exports = __webpack_public_path__ + "img/LogoSGC.c6b35a58.svg";